import { authFetch } from "../../utils/authFetch";

const apiURL = require('./apiURL');
const fetch = authFetch;

const Types = {
    VIDEO_UPDATED_COMPLETION: "VIDEO_UPDATED_COMPLETION",
    VIDEO_COURSE_COMPLETION: "VIDEO_COURSE_COMPLETION"
};

const updatedVideoCompletion = (video) => ({
    type: Types.VIDEO_UPDATED_COMPLETION,
    video
});

const updateVideoCompletion = (video) => {
    return (dispatch, getState) => {

        const path = `/settings/courses/`
        console.log("video", video)

        fetch(apiURL + path, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(video),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => dispatch(updatedVideoCompletion(data)));
            
    }
};

const updatedCourseCompletion = (payload) => ({
    type: Types.VIDEO_COURSE_COMPLETION,
    payload
});

const getCourseCompletion = (courseID) => {
    return (dispatch, getState) => {

        const path = `/settings/courses/${courseID}`

        fetch(apiURL + path, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => dispatch(updatedCourseCompletion(data)));
            
    }
};

const Actions = {
    updateVideoCompletion,
    getCourseCompletion,
};

export { Types, Actions };